import { motion } from 'framer-motion';

const steps = [
  { step: '01', title: 'Discover', desc: 'Goals, constraints, compliance context, and current pain points.' },
  { step: '02', title: 'Design', desc: 'Target architecture, security model, and phased plan with costs.' },
  { step: '03', title: 'Deliver', desc: 'Implementation, testing, cutover, and knowledge transfer.' },
  { step: '04', title: 'Sustain', desc: 'Monitoring, improvements, and roadmap for what comes next.' },
];

const Process = () => {
  return (
    <section id="process" className="py-20 md:py-28 scroll-mt-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center max-w-2xl mx-auto mb-14"
        >
          <h2 className="font-display text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            How we <span className="text-gradient">engage</span>
          </h2>
          <p className="text-slate-600 text-lg">
            A simple, repeatable model—whether you need a focused project or ongoing partnership.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {steps.map((s, i) => (
            <motion.div
              key={s.step}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.06, duration: 0.45 }}
              className="relative rounded-2xl border border-slate-200 bg-surface shadow-card p-6 overflow-hidden"
            >
              <span className="absolute top-4 right-4 text-4xl font-display font-bold text-slate-200 select-none">
                {s.step}
              </span>
              <p className="text-xs font-bold uppercase tracking-widest text-brand-violet mb-3">Step {s.step}</p>
              <h3 className="font-display font-semibold text-lg text-slate-900 mb-2">{s.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
